// extracted by mini-css-extract-plugin
module.exports = {"select":"PureSelect_select__hWaN4"};